<button *ngIf="isDesktop" (click)="goToPrintAndPost()" type="button" id="create-mail" class="btn btn-info mr-3"><i
    class="fa fa-map-marker mr-1 text-white" aria-hidden="true"></i>
    {{'DIGITALMAILBOX.PrintandPostButton' | translate}}
</button>

<button *ngIf="!isDesktop" (click)="goToPrintAndPost()" type="button" id="create-mail" class="btn btn-info btn-w150 font-12 "><i
    class="fa fa-map-marker mr-1 text-white" aria-hidden="true"></i>
    {{'DIGITALMAILBOX.PrintandPostButton' | translate}}
</button> 